import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { analytics } from './analytics';
import ErrorBoundary from './components/ErrorBoundary';
import { RegistrationProvider } from './context/RegistrationContext';
import { loadRuntimeConfig } from './utils/runtimeConfig';

async function bootstrap() {
    await loadRuntimeConfig();
    await analytics.initialize();
    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement,
    );
    root.render(
        <ErrorBoundary>
            <HelmetProvider>
                <RegistrationProvider>
                    <Suspense fallback={<div>Loading...</div>}>
                        <App />
                    </Suspense>
                </RegistrationProvider>
            </HelmetProvider>
        </ErrorBoundary>,
    );
}

bootstrap();
